import React from 'react';
import { useTranslation } from 'react-i18next';
import { CustomFreshChatBtn } from 'common/ui/themes/disona/atoms/CustomFreshChatBtn';
import { BurgerBtn } from 'common/ui/themes/disona/atoms/BurgerBtn';
import { observer } from 'mobx-react-lite';
import { inject } from 'mobx-react';
import { DISONA_MODAL_IDS } from 'common/constants/modal.constants';
import { Logo } from '../Logo';
import * as S from './styled';

const Header = ({ renderUnderHeader, ModalStore, pageName }) => {
  const { t } = useTranslation();

  return (
    <S.Header>
      <S.HeaderInner>
        {<S.PageName>{pageName}</S.PageName> || <Logo />}
        <S.MobControls>
          <CustomFreshChatBtn style={{ marginRight: '10px' }} />
          <BurgerBtn
            onClick={() => {
              ModalStore.push(DISONA_MODAL_IDS.APP_MENU);
            }}
          />
        </S.MobControls>
      </S.HeaderInner>
      {renderUnderHeader && renderUnderHeader()}
    </S.Header>
  );
};

export default inject(
  'ProfileStore',
  'ModalStore',
  'AppStore',
)(observer(Header));
